import { Box, Button, Grid, TextField, Typography } from "@mui/material"
import React, { useEffect, useState } from "react"
import ModalDialogPage from "src/components/modal-dialog"
import TableGray from "src/components/table/table-gray"
import EmissaoService from "src/services/emissao-service"
import PropTypes from 'prop-types'
import { DATE_FORMAT, DATE_FORMAT_SHOW } from "src/utils/constants"
import dayjs from "dayjs"
import SkeletonLine from "src/components/skeleton-line"
import { formatDecimalCaseReplaceComma, formatDecimalCaseWithComma, formatStringToFloatDecimalCase } from "src/utils/format-decimal"
import { ordenaPorDataReferencia } from "src/utils/date-format"
import ParameterTable from "src/components/table/parameter-table"
import AlertMessage from "src/components/alert-message"

const tableDefault = [
    {
        cells: ["CETIP: ", "ISIN: "]
    }
]

const UltimosNegocios = ({ value, cetipIsin }) => {
    const emissaoService = new EmissaoService()
    const ultimoNegocioDefault = { data_referencia: "", pupar: "", spread_credito: "" }
    const [openMostrarTodos, setOpenMostrarTodos] = useState(false)
    const [ultimoNegocioState, setUltimoNegocioState] = useState(ultimoNegocioDefault)
    const [loadingUltimoNegocio, setLoadingUltimoNegocio] = useState(false)
    const [rowsUltimoNegocio, setRowsUltimoNegocio] = useState([])
    const [table, setTable] = useState(tableDefault)
    const [alertMessageState, setAlertMessageState] = React.useState({
        open: false,
        message: "",
        type: ""
    })

    useEffect(() => {
        if (validateValue()) loadData(value)
    }, [value])

    const validateValue = () => {
        if (value && value.length > 4) {
            return true
        }

        return false
    }

    const loadData = (cetipIsin) => {
        setLoadingUltimoNegocio(true)
        emissaoService.getUltimoSpreadNegociados(cetipIsin).then((response) => {
            const { body } = response
            const { data } = body

            if (data !== null) {
                const { DataReferencia, PercentualPUPAR, SpreadCreditoFinal } = data

                setUltimoNegocioState({
                    data_referencia: dayjs(DataReferencia).format(DATE_FORMAT_SHOW),
                    pupar: formatDecimalCaseReplaceComma(PercentualPUPAR),
                    spread_credito: formatDecimalCaseWithComma(SpreadCreditoFinal, 4),
                })
            } else {
                setUltimoNegocioState(ultimoNegocioDefault)
            }
        }).catch(() => {
            setUltimoNegocioState(ultimoNegocioDefault)
        }).finally(() => {
            setLoadingUltimoNegocio(false)
        })
    }

    const buildTable = () => {
        setTable([{ cells: [`CETIP: ${cetipIsin.CETIP}`, `ISIN: ${cetipIsin.ISIN}`] }])
    }

    const openUltimoNegocioModal = () => {
        setAlertMessageState({ open: false, message: "", type: "" })
        if (!validateValue()) {
            setOpenMostrarTodos(true)
            openAlert('Não há dados para o CETIP consultado.', 'warning')
            return
        }

        buildTable()
        setOpenMostrarTodos(true)
        setLoadingUltimoNegocio(true)
        const dataMeno60Dias = dayjs().subtract(60, 'day')
        const minus60Days = dataMeno60Dias.format(DATE_FORMAT)
        console.log(minus60Days)
        // emissaoService.ultimoNegocios("get", `?CETIP=${value.toUpperCase()}&DataReferencia__gte=${minus60Days}`)
        emissaoService.ultimoNegocios("get", `?CETIP=${value.toUpperCase()}`)
            .then((response) => {
                setOpenMostrarTodos(true)
                const { body } = response
                const { results } = body
                if (!results || results.length === 0) {
                    openAlert("Não há dados para o CETIP consultado.", "warning")
                } else {
                    setAlertMessageState({ open: false, message: "", type: "" })
                }
                const rows = ordenaPorDataReferencia(results, "desc").map((obj, index) => ({ ...obj, id: index }))
                setRowsUltimoNegocio(rows)
            })
            .catch(() => { 
                openAlert("Erro ao buscar os dados. Tente novamente.", "error") 
            })
            .finally(() => {
                setLoadingUltimoNegocio(false)
            })
    }

    const openAlert = (message, type) => {
        setAlertMessageState({
            ...alertMessageState,
            open: true,
            message: message,
            type: type
        })
    }

    const closeAlert = () => {
        setAlertMessageState({ ...alertMessageState, open: false })
    }

    return <>
        {loadingUltimoNegocio ? (
            <Box sx={{ minHeight: '96px' }}> 
                <SkeletonLine />
            </Box>
        ) : (
            <Grid container direction="row" alignItems={"center"} justifyContent="space-between" spacing={2}>
                {ultimoNegocioState.data_referencia || ultimoNegocioState.pupar || ultimoNegocioState.spread_credito ? (
                    <>
                        <Grid item xs={12} md={3} sm={12} xl={3}>
                            <TextField fullWidth label="Data Referência" value={ultimoNegocioState.data_referencia} />
                        </Grid>
                        <Grid item xs={12} md={3} sm={12} xl={3}>
                            <TextField fullWidth label="%PUPAR" value={ultimoNegocioState.pupar} />
                        </Grid>
                        <Grid item xs={12} md={3} sm={12} xl={3}>
                            <TextField fullWidth label="Spread Crédito" value={ultimoNegocioState.spread_credito} />
                        </Grid>
                    </>
                ) : (
                    <Grid item xs={8}>
                        <Typography variant="body2" color="black" align="center">
                            Não há negócios para o CETIP consultado.
                        </Typography>
                    </Grid>
                )}
                <Grid item xs={12} md={3} sm={12} xl={3}>
                    <Button fullWidth variant="contained" onClick={openUltimoNegocioModal}>Mostrar Todos</Button>
                </Grid>
            </Grid>
        )}

        <ModalDialogPage open={openMostrarTodos}
            title="Histórico Das Últimas Negociações"
            close={() => {
                setOpenMostrarTodos(false)
            }}>
            <>
                <Grid container direction="column" spacing={2}>
                    <Grid item xs={12} md={12} xl={12}>
                        <TableGray data={table} />
                        <Grid item xs={12} style={{ marginTop: 8 }}>
                            <AlertMessage open={alertMessageState.open} message={alertMessageState.message} type={alertMessageState.type} close={closeAlert} />
                        </Grid>
                    </Grid>
                </Grid>
                <br />
                <Grid container direction="column">
                    <Grid item xs={12} md={12} xl={12}>
                        {loadingUltimoNegocio ? <SkeletonLine /> : (
                            <ParameterTable
                                columns={[
                                    { field: 'DataReferencia', headerName: 'Data Referencia', flex: 1, renderCell: (params) => dayjs(params.value).format(DATE_FORMAT_SHOW) },
                                    { field: 'PU_MTM', headerName: 'PU MTM', flex: 1, renderCell: (params) => formatStringToFloatDecimalCase(params.value, 4, 4) },
                                    { field: 'PercentualPUPAR', headerName: '%PUPAR', flex: 1, renderCell: (params) => formatStringToFloatDecimalCase(params.value, 2, 2) },
                                    { field: 'TaxaMTM', headerName: 'Taxa MTM', flex: 1, renderCell: (params) => formatStringToFloatDecimalCase(params.value, 4, 4) },
                                    { field: 'SpreadCreditoFinal', headerName: 'Spread Crédito', flex: 1, renderCell: (params) => formatStringToFloatDecimalCase(params.value, 4, 4) },
                                    { field: 'VolumeFinanceiro', headerName: 'Volume Financeiro', flex: 1, renderCell: (params) => formatStringToFloatDecimalCase(params.value, 2, 2) },
                                ]}
                                data={rowsUltimoNegocio}
                                setData={setRowsUltimoNegocio}
                                createRow={() => { }}
                                deleteRow={() => { }}
                                updateRow={() => { }}
                                loadData={loadData}
                                disableDeleteColumn={true}
                                disableAddRow={true}
                                buttonAddVariant={""}
                                buttonAddTitle={""}
                            />
                        )}
                    </Grid>
                </Grid>
            </>
        </ModalDialogPage>
    </>
}

UltimosNegocios.propTypes = {
    value: PropTypes.string,
    cetipIsin: PropTypes.object,
    loading: PropTypes.func,

}

export default UltimosNegocios